import React from 'react';
import {
    AppType,
    Card,
    ExamApplicationStatus,
    ExamStatus,
    MappedExamApplicationStatuses,
    MappedExamStatuses,
    renderRow, TextLink,
} from 'components';
import { Color, ColorStatus } from '_helpers';
import cn from 'classnames';
import styles from './ResultAndStatusTab.module.scss';
import moment from 'moment';
import CertPreview from '../../QualificationInfoDetails/cert-preview.jpg';

const ResultAndStatusTab = ({
    data, appType, cardCategory, cardTitle, withoutPadding,
}: IProps) => {
    const {
        examApplicationStatus, processedByNark, finalized, examStatus, narkPageUrl, certificateUrl
    } = data;
    const processingExamStatus = (examStatus === ExamStatus.AwaitingExpertConfirmation
        || examStatus === ExamStatus.IsApplying
        || examStatus === ExamStatus.ApplyingFinished
        || examStatus === ExamStatus.IsPassing
        || examStatus === ExamStatus.Canceled || (!processedByNark && appType === AppType.Applicant))
    || examApplicationStatus === ExamApplicationStatus.Absent || examApplicationStatus === ExamApplicationStatus.Canceled;

    const processingColorStatus = processingExamStatus ? new ColorStatus(Color.Default, 'Обработка') : null;
    const finalizedColorStatus = !finalized ? new ColorStatus(Color.Default, 'Ожидает финализации') : null;

    const theoryStatus = processingColorStatus || (examApplicationStatus === ExamApplicationStatus.Passed || data.isPassedTheory === true
        ? new ColorStatus(Color.Success, 'Сдана')
        : new ColorStatus(Color.Red, 'Не сдана'));

    const practiceStatus = (processingColorStatus || finalizedColorStatus) || (examApplicationStatus === ExamApplicationStatus.Passed
        ? new ColorStatus(Color.Success, 'Сдана')
        : new ColorStatus(Color.Red, 'Не сдана'));

    const fullStatus = (processingColorStatus || finalizedColorStatus) || (examApplicationStatus === ExamApplicationStatus.Passed
        ? new ColorStatus(Color.Success, 'Экзамен сдан')
        : new ColorStatus(Color.Red, 'Экзамен не сдан'));

    let processStatus = MappedExamApplicationStatuses[data.examApplicationStatus].text;
    if (appType === AppType.Applicant && examStatus !== ExamStatus.Canceled) {
        processStatus = processedByNark ? 'Утвержден' : 'Обработка';
    } else if (!processingExamStatus) {
        switch (data.examStatus) {
            case ExamStatus.Finished:
            case ExamStatus.FinalizedResults:
                processStatus = 'На стороне ЦОК';
                break;
            case ExamStatus.NokProtocolSigned:
            case ExamStatus.AkProtocolSigned:
            case ExamStatus.SovietProtocolSignedByMembers:
                processStatus = 'На стороне СПКФР';
                break;
            default:
                processStatus = MappedExamStatuses[data.examStatus].text;
                break;
        }
    }

    return (
        <Card
          title={cardTitle !== null ? (cardTitle || 'Результат и статус') : undefined}
          category={cardCategory !== null ? (cardCategory || 'Результат и текущий статус обработки результатов экзамена') : undefined}
          withoutPadding={withoutPadding}
          withoutBorder
        >
            {processingExamStatus ? null : renderRow('ТЕОРЕТИЧЕСКАЯ ЧАСТЬ', theoryStatus.text, styles.row, theoryStatus.color)}
            {processingExamStatus ? null : renderRow('ПРАКТИЧЕСКАЯ ЧАСТЬ', practiceStatus.text, styles.row, practiceStatus.color)}
            {processingExamStatus ? null : renderRow('ИТОГОВЫЙ РЕЗУЛЬТАТ', fullStatus.text, styles.row, fullStatus.color)}

            {renderRow('СТАТУС ОБРАБОТКИ', processStatus, cn(styles.row, !processingExamStatus && 'mt-5'))}
            {renderRow('ДАТА СТАТУСА ', data.statusChangeTime.format('DD.MM.YYYY'), styles.row)}

            {narkPageUrl && renderRow('ЗАПИСЬ В РЕЕСТРЕ', <TextLink text="Ссылка на запись" link={narkPageUrl} withIcon />)}
            {certificateUrl && renderRow(examApplicationStatus === ExamApplicationStatus.Passed ? 'СВИДЕТЕЛЬСТВО' : 'ЗАКЛЮЧЕНИЕ', <TextLink text="Скачать документ" link={certificateUrl} withIcon />)}
        </Card>
    );
};

export default ResultAndStatusTab;

export interface IProps {
    data: IResultAndStatus;
    appType: AppType;
    cardTitle?: string | null;
    cardCategory?: string | null;
    withoutPadding?: boolean;
}

interface IResultAndStatus {
    isPassedTheory?: boolean | undefined;
    examApplicationStatus: ExamApplicationStatus;
    examStatus: ExamStatus;
    processedByNark: boolean;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    narkPageUrl?: string | undefined;
    certificateUrl?: string | undefined;
}
